import React from "react";
import "Styles/Global/PackagePreviewCard.scss";
import {
  IonCard,
  IonCardHeader,
  IonCardTitle,
  IonCardSubtitle,
} from "@ionic/react";
import { to_dollars_cents } from "Utils";

const consultationLabel = (count) =>
  count + " consultation" + (count === 1 ? "" : "s");

const PackagePreviewCard = ({ package_data, ...rest }) => {
  const { dollars, cents } = to_dollars_cents(package_data.price_cents);

  return (
    <IonCard
      className={`package-preview-card ${rest.className ? rest.className : ""}`}
      {...rest}
    >
      <IonCardHeader className="title">
        <div className="heading-row">
          <IonCardTitle>{package_data.name}</IonCardTitle>
          <span className="price">
            $<strong>{dollars}</strong>.<span>{cents}</span>
          </span>
        </div>
        <IonCardSubtitle className="title-consultation-count">
          {consultationLabel(package_data.included_consultations_count)}
        </IonCardSubtitle>
      </IonCardHeader>
      <article
        className="image"
        style={{ backgroundImage: "url(" + package_data.image.url + ")" }}
      />
    </IonCard>
  );
};

export default PackagePreviewCard;
